module.exports = __webpack_public_path__ + "img/small-arrow-right.695eea01.svg";